import React from 'react';
import SEOHead, { faqSchema } from '@components/marketing/SEOHead';
import PageHead from '@components/marketing/PageHead';
import CtaBand from '@components/marketing/CtaBand';
import { SPORTS } from './content';

const FAQS = [
  ['Which sports does SportsTMS support?',
   'Box cricket, football, badminton, volleyball, table tennis, pickleball, carrom and chess are supported out of the box, each with its own scoring model. Further sports are added as configuration rather than as a rebuild.'],
  ['Can the scoring rules be changed for our format?',
   'Yes. Game length, sets, win-by-two, ceilings, overs, squad sizes and tie-breaks are all settings. If your badminton is best of three to twenty-one rather than eleven, that is a configuration change, not a different product.'],
  ['What stops a scorer entering an impossible score?',
   'The scoring screen knows the sport. It will not let a badminton game run past the point it would have ended, it closes a cricket innings when the side is all out, and it ends a match as soon as one side has the games or sets it needs.'],
  ['Can we add a sport you do not list?',
   'If it is scored by points, games, sets or a simple win and loss, it can be configured. Tell us the format on the demo call and we will say plainly whether it fits.'],
];

const SportsPage = () => (
  <>
    <SEOHead
      title="Sports and scoring"
      description="How each sport is scored: box cricket ball by ball, badminton game by game with deuce, football goals and scorers, and five more."
      schema={faqSchema(FAQS)}
    />

    <PageHead title="Every sport keeps its own rules" image="/images/sportstms/cricket.jpg">
          <p>
            A generic scoreboard can record a number. It cannot tell you whether the number is
            possible. Each sport here is scored the way it is played, which is what makes the
            tables built from those results worth reading.
          </p>
    </PageHead>

    <section className="stms-sec">
      <div className="stms-wrap">
        <div className="stms-sportlist">
          {SPORTS.map((s) => (
            <article key={s.sport}>
              <h2>{s.sport}</h2>
              <p className="stms-sportlist__how">{s.how}</p>
              <p>{s.detail}</p>
              <dl className="stms-pairs">
                <div><dt>Played on</dt><dd>{s.units}</dd></div>
                <div><dt>Produces</dt><dd>{s.produces}</dd></div>
              </dl>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="stms-sec stms-sec--paper">
      <div className="stms-wrap">
        <div className="stms-lede"><h2>Common questions</h2></div>
        <dl className="stms-faq">
          {FAQS.map(([q, a]) => (
            <div key={q}><dt>{q}</dt><dd>{a}</dd></div>
          ))}
        </dl>
      </div>
    </section>

    <CtaBand title="Tell us your format" image="/images/sportstms/hero-court.jpg" action="Book a demo">
      <p>Bring the rules you actually play to. We will show you the scoring screen for your sport.</p>
    </CtaBand>
  </>
);

export default SportsPage;
